import { ProductsContainer } from '@/modules/AkeneoSync';

export const AkeneoProducts = (): JSX.Element => <ProductsContainer />;

export default AkeneoProducts;
